import React from 'react';
import { Reveal } from './Reveal';
const benefits = [{
  icon: '🚫',
  title: 'Você nunca mais aceita encomenda no prejuízo (sem saber).',
  text: 'Você define a margem mínima que aceita. Se cair abaixo, o app avisa antes de você mandar o orçamento. Adeus "descobrir tarde demais".'
}, {
  icon: '💬',
  title: 'Cliente nunca mais te pega de surpresa pedindo desconto.',
  text: 'Você sabe na hora qual é o seu chão. "Posso dar 10%? Posso dar 15%?" Vira pergunta com resposta.'
}, {
  icon: '📈',
  title: 'Você para de "engolir" o aumento dos materiais.',
  text: 'Insumo subiu? Você atualiza no app, todos os produtos se reajustam, e você sabe o novo preço justo na hora. Sem culpa de cobrar mais — porque agora você TEM o número.'
}, {
  icon: '😴',
  title: 'Sexta-feira de noite, você dorme em paz.',
  text: 'Sabe o que entregou. Sabe o que ainda falta. Sabe quanto faturou na semana. Sabe quanto sobrou. Sem caderno aberto na mesa, sem ansiedade no coração.'
}];
export const BenefitsSection = () => {
  return <section id="beneficios" className="py-12 md:py-16 px-[5vw] bg-bg overflow-hidden" data-id="element-18">
      <div className="max-w-3xl mx-auto" data-id="element-19">
        <Reveal data-id="element-20">
          <div data-id="element-21">
            <span className="font-caveat text-rose text-2xl block mb-4" data-id="element-22">
              o que muda na sua vida
            </span>
            <h2 className="font-serif font-bold text-[26px] md:text-[clamp(34px,4vw,48px)] tracking-[-0.02em] text-ink mb-10 leading-tight" data-id="element-23">
              O lucro que <span className="italic text-rose" data-id="element-24">existia</span>, mas
              você não enxergava
            </h2>

            <div className="space-y-8" data-id="element-25">
              {benefits.map((b, i) => <div key={i} className={`flex gap-5 ${i < benefits.length - 1 ? 'pb-8 border-b border-line' : ''}`} data-id="element-26">
                  <div className="w-10 h-10 rounded-2xl bg-rose-soft flex items-center justify-center flex-shrink-0 text-lg" data-id="element-27">
                    {b.icon}
                  </div>
                  <div data-id="element-28">
                    <h4 className="font-serif font-semibold text-[16px] md:text-[19px] text-ink mb-2" data-id="element-29">
                      {b.title}
                    </h4>
                    <p className="text-[14px] md:text-[15px] text-ink-soft leading-relaxed" data-id="element-30">
                      {b.text}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
};